import { useContext } from 'react';
import CompanyContext from '../../contexts/company/CompanyContext';
import { useMySubscriptionId } from '../../hooks/subscription/useMySubscriptionId';

// Kept apart from the pages' path constants so the header does not import the pages it is rendered in
const COMPANY_TABS = [
  { key: 'users', title: 'Utilisateurs', supervisorOnly: true },
  { key: 'numbers', title: 'Numéros', supervisorOnly: true },
  { key: 'ai-receptionist', title: 'Réceptionniste IA', supervisorOnly: false },
  { key: 'billing', title: 'Facturation', supervisorOnly: true },
  { key: 'settings', title: 'Paramètres', supervisorOnly: true },
] as const;

export type CompanyTabKey = (typeof COMPANY_TABS)[number]['key'];

export const COMPANY_PAGE_PATH = '/company';

export const getCompanyTabPath = (key: CompanyTabKey) => `${COMPANY_PAGE_PATH}/${key}`;

// A member only sees their own receptionist, and nothing at all without a subscription
export const useCompanyTabs = () => {
  const { activeCompany } = useContext(CompanyContext);
  const mySubscriptionId = useMySubscriptionId();
  const isSupervisor = !!activeCompany?.isSupervisor;

  return COMPANY_TABS.filter((tab) => isSupervisor || (!tab.supervisorOnly && !!mySubscriptionId)).map(
    (tab) => ({ ...tab, path: getCompanyTabPath(tab.key) })
  );
};
